import { Component, OnInit, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { EmplacementStockDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-emplacement',
  templateUrl: './emplacement.component.html',
  styleUrls: ['./emplacement.component.css']
})
export class EmplacementComponent implements OnInit {

  @Select(ControlPanelStore.emplacements$) emplacements$: Observable<EmplacementStockDto[]>;

  private _emplacementId: number = null;
  Emplacements: EmplacementStockDto[] = [];

  @Input()
  get emplacementId() {
    return this._emplacementId;
  }
  set emplacementId(val) {
    this._emplacementId = val;
    this.getEmplacementInComponent();
  }

  EmplacementInComponent: string;

  e: Subscription;

  constructor() { }

  ngOnInit() {
    this.e = this.emplacements$.subscribe(res => {
      if (res != null) {
        this.Emplacements = res;
        this.getEmplacementInComponent();
      }
    });
  }

  getEmplacementInComponent() {
    let emplacement = this.Emplacements.find(c => c.Id == this.emplacementId);
    this.EmplacementInComponent = (emplacement) ? emplacement.Nom : null;
  }

  ngOnDestroy() {
    this.e?.unsubscribe();
  }
}
